import { Modal as MantineModal, ModalProps } from '@mantine/core';

export type IBaseModalProps = ModalProps;

/** @registry Design-layer, unopinionated pass-through over Mantine Modal; prefer src/design/molecules/Modal for standard-footer dialogs. Extend here when BaseModal needs house behavior. */
export const BaseModal = MantineModal;
